/**
 * Table component displaying all field changes with operations, values, and confidence scores.
 */

import React from 'react'
import type { ChangeSet, ExtractedField } from 'shared-libs/generated/server-types/entity/blocks/aiBlockUsageEntity'
import type { IAiBlockActivityOptions } from './ai-block-activity-types'
import { computeFieldRows } from './ai-block-activity-helpers'
import { FieldsTableView } from './fields-table-view'

interface IFieldsTableProps {
  options: IAiBlockActivityOptions
  changeSet?: ChangeSet
  extractedFields?: ExtractedField[]
}

export const FieldsTable: React.FC<IFieldsTableProps> = ({ options, changeSet, extractedFields }) => {
  const fieldRows = React.useMemo(() => {
    return computeFieldRows(options, changeSet, extractedFields)
  }, [changeSet, extractedFields, options])

  return (
    <FieldsTableView
      rows={fieldRows}
      showOperation={true}
      showConfidenceBar={false}
      headerText='Changes Applied'
      emptyMessage='No changes were made in this execution.'
    />
  )
}
